module.exports = __webpack_public_path__ + "img/faqs.da69b2b0.png";